import mBaseModel from "@/models/mBaseModel";
import UtilsData  from "@/utilities/UtilsData";

export default class mReportColumn extends mBaseModel {
  constructor(rawModelFields = {}) {
    super(rawModelFields);
    this.ats.Id       = 0;
    this.ats.Order    = null;
    this.ats.Name     = null;
    this.ats.DataType = 'Auto';
    this.ats.Format   = null;
    this.ats.DbName   = null;
    this.ats.ReportId = null;
    this.ats.Total    = false;
    this.setRawFields(rawModelFields);
  }

  // ##################################################
  // region Data Sources
  static vocDataTypeFormat() {
    const voc = {
      'Auto':                                null,
      'String. Aligned left':                {classes: 'text-left'},
      'String. Aligned right':               {classes: 'text-right'},
      'String. Aligned center':              {classes: 'text-center'},
      'Number. Simple. Integer':             {classes: 'text-right', func: 'formatDollarValue', funcParams: [0]},
      'Number. Commas. 2 decimals':          {classes: 'text-right', func: 'formatDollarValue', funcParams: [2]},
      'Number. Commas. 4 decimals':          {classes: 'text-right', func: 'formatDollarValue', funcParams: [4]},
      'Percent. 4 decimals': {classes: 'text-right', func: 'formatPercentValue', funcParams: [4]},
      'Date short. 02/13/2021':              {classes: 'text-left', func: 'formatDateString', funcParams: ['MM/DD/YYYY']},
      'Date Time. 02/13/2021 11:59 PM':      {classes: 'text-left', func: 'formatDateString', funcParams: ['MM/DD/YYYY hh:mm A']}
    };
    return voc;
  }

  // endregion Data Sources
  // ##################################################
  validate() {
    this._localValidationStatus  = true;
    this._localValidationResults = [];
    const modelName              = `Column [Order ${this.ats.Order}]`;
    const id                     = this.ats.Id;
    // #####
    if (UtilsData.isEmpty(this.ats.Name)) this._localValidationResults.push({field: 'Name', msg: 'Field is required', modelName: modelName, id: id});
    if (UtilsData.isNull(this.ats.DbName)) this._localValidationResults.push({field: 'DbName', msg: 'Field is required', modelName: modelName, id: id});
    if (UtilsData.isNull(this.ats.DataType)) this._localValidationResults.push({field: 'DataType', msg: 'Field is required', modelName: modelName, id: id});
    // #####
    this._localValidationStatus = this._localValidationResults.length === 0;
    return this._localValidationResults;
  }

  // ##################################################
}
